import { render } from "./teacherBusyness.vue?vue&type=template&id=0a5766e2"
import script from "./teacherBusyness.vue?vue&type=script&lang=js"
export * from "./teacherBusyness.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__